import env from './env';

const UUID_LOCAL_STORAGE_KEY = 'uuid';

const getUUID = (): string | null => {
  const uuid = localStorage.getItem(UUID_LOCAL_STORAGE_KEY);
  if (!uuid) window.location.replace(`${env.envURL}/get-the-box`);
  return uuid;
};

export default getUUID;
